// LogFilterDialog - MODULE
// ***********************************************************************************************************************
import { Grid, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { DatePicker } from "../../framework/DateTime/DatePicker";
import { DrawerContent } from "../../framework/Drawer/DrawerContent";
import { FilterButtons } from "../../framework/Filters/FilterButtons";
import { FilterSearchField } from "../../framework/Filters/FilterSearchField";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";

//LogFilterDialog
export interface ILogFilterDialogProp {
    classes?: string;
    filter: IListFilterItem;
    eventTypes: IIdTitle[];
    timeFilters: IIdTitle[];
    selectedLogEventTypes: string[];
    selectedTimeFilterId: string;
    startDateStr: string;
    endDateStr: string;
    canRemoveSharedFilters: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, selectedTimeFilterId: string, selectedLogEventTypes: string[], startDateStr: string, endDateStr: string) => any;
    onCancel: () => void;
}

export interface ILogFilterDialogState {
    selectedLogEventTypes: string[];
    selectedTimeFilterId: string;
    startDateStr: string;
    endDateStr: string;
}

export class LogFilterDialog extends React.Component<ILogFilterDialogProp, ILogFilterDialogState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: ILogFilterDialogProp): ILogFilterDialogState => {
        return {
            selectedTimeFilterId: props.selectedTimeFilterId,
            selectedLogEventTypes: props.selectedLogEventTypes.slice(0),
            startDateStr: props.startDateStr,
            endDateStr: props.endDateStr
        };
    };

    constructor(props: ILogFilterDialogProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: ILogFilterDialogProp, prevState: ILogFilterDialogState): void {
        const props = this.props;
        if (!prevProps || prevProps.filter.getHash() === props.filter.getHash()) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "selectedTimeFilterId") {
            this.setState({ selectedTimeFilterId: value });
        }
    };

    handleChangeEventTypes = (selectedLogEventTypes: string[]) => {
        this.setState({
            selectedLogEventTypes
        });
    };

    dateChange = (startDate: Date, endDate: Date) => {
        if (!startDate && !endDate && endDate < startDate) {
            endDate = startDate;
        }
        const startDateStr = startDate ? Base.utcTimeToDateStr(startDate.getTime()) : "";
        const endDateStr = endDate ? Base.utcTimeToDateStr(endDate.getTime()) : "";
        this.setState({
            startDateStr,
            endDateStr
        });
    };

    handleStartDateChange = (value: string) => {
        this.setState({ startDateStr: value });
    };

    handleStartDateBlur = (value: string) => {
        const state = this.state;
        this.dateChange(value ? value.toUtcDate() : null, state.endDateStr ? state.endDateStr.toUtcDate() : null);
    };

    handleEndDateChange = (value: string) => {
        this.setState({ endDateStr: value });
    };

    handleEndDateBlur = (value: string) => {
        const state = this.state;
        this.dateChange(state.startDateStr ? state.startDateStr.toUtcDate() : null, value ? value.toUtcDate() : null);
    };

    getSaveDataFromState = (props: ILogFilterDialogProp, state: ILogFilterDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("selectedTimeFilterId", state.selectedTimeFilterId ? state.selectedTimeFilterId : null);
        result.append("selectedLogEventTypes", state.selectedLogEventTypes);
        result.append("startDateStr", state.startDateStr ? state.startDateStr : null);
        result.append("endDateStr", state.endDateStr ? state.endDateStr : null);
        return result;
    };
    
    static filterIsSet = (timeFilters: IIdTitle[], eventTypes: IIdTitle[],
        selectedTimeFilterId: string, selectedLogEventTypes: string[]): boolean => {
        return !(selectedTimeFilterId === timeFilters[0].id &&
            Base.equalStrArrays(selectedLogEventTypes, [eventTypes[0].id]));
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        if (!saveAs) {
            props.onOk(false, state.selectedTimeFilterId, state.selectedLogEventTypes, state.startDateStr, state.endDateStr);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, state.selectedTimeFilterId, state.selectedLogEventTypes, state.startDateStr, state.endDateStr);
            });
        }
    };

    handleClear = () => {
        const props = this.props;
        const nowDate = Base.getNowUtcDate();
        this.setState({
            selectedTimeFilterId: props.timeFilters[0].id,
            selectedLogEventTypes: [props.eventTypes[0].id],
            startDateStr: Base.utcTimeToDateStr(nowDate.addDays(-60).getTime()),
            endDateStr: Base.utcTimeToDateStr(nowDate.getTime())
        });
    };

    handleSearch = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(true, state.selectedTimeFilterId, state.selectedLogEventTypes, state.startDateStr, state.endDateStr);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSearch, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };
    
    render() {
        const props = this.props;
        const state = this.state;
        return (
            <DrawerContent
                content={
                    <>
                        <FilterSearchField
                            filter={props.filter}
                            canRemoveSharedFilters={props.canRemoveSharedFilters}
                            onSaveFilter={this.handleSaveFilter}
                            onRemoveFilter={props.onRemoveFilter}
                        />
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.LogEventType}>
                                    <CheckboxDropdown
                                        required={true}
                                        toggleAll={true}
                                        toggleAllId="0"
                                        selectedIds={state.selectedLogEventTypes}
                                        values={props.eventTypes}
                                        onChange={this.handleChangeEventTypes}
                                    />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.LogEventTime}>
                                    <Select name="selectedTimeFilterId" title={Translations.LogEventTime} value={state.selectedTimeFilterId} onChange={this.handleChange}>
                                        {props.timeFilters.map(timeFilter =>
                                            <MenuItem key={timeFilter.id} value={timeFilter.id}>{timeFilter.title}</MenuItem>
                                        )}
                                    </Select>
                                </FormField>
                            </Grid>
                        </GridRow>
                        {state.selectedTimeFilterId === "5" &&
                            <GridRow sx={{ marginTop: "0" }}>
                                <Grid item sm={6}>
                                    <DatePicker
                                        //title={Translations.SearchStartDate}
                                        value={state.startDateStr}
                                        required={true}
                                        onChange={this.handleStartDateChange}
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    <DatePicker
                                        //title={Translations.SearchEndDate}
                                        value={state.endDateStr}
                                        required={true}
                                        onChange={this.handleEndDateChange}
                                    />
                                </Grid>
                            </GridRow>
                        }
                    </>
                }
                actions={
                    <FilterButtons
                        onCancel={this.handleCancel}
                        onClear={this.handleClear}
                        onSave={this.handleSearch}
                    />
                }
            />
        );
    }
}